import { createSlice } from '@reduxjs/toolkit';

const gamesSlice = createSlice({
  name: 'games',
  initialState: {
    source: {},
    players: {},
    providers: {},
    statistic: {
      filter: {},
      result: []
    }
  },
  reducers: {
    setSource: (state, action) => {
      state.source = action.payload;
    },
    setPlayers: (state, action) => {
      const { data, groupId } = action.payload;
      state.players[groupId] = data;
    },
    setProviders: (state, action) => {
      const { data, sourceId } = action.payload;
      state.providers[sourceId] = data;
    },
    setStatisticFilter: (state, action) => {
      state.statistic.filter = action.payload;
    },
    setStatisticResult: (state, action) => {
      state.statistic.result = action.payload;
    }
  }
});

export default gamesSlice.reducer;

export const { setSource, setPlayers, setProviders, setStatisticFilter, setStatisticResult } =
  gamesSlice.actions;
